

const spinnerOn = () => {
    const spinner = document.getElementById('spinner');
    spinner.classList.remove('d-none');
}

const spinnerOff = () => {
    spinner.classList.add('d-none');
}

export {
    spinnerOn,
    spinnerOff
}
